module.exports = __webpack_public_path__ + "img/underwriting_book_snapshot.2a0b0bff.png";